// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
// eslint-disable-next-line spire/fenced-imports

import HeaderClickable from "@conklin/App/Components/Header/HeaderClickable";
import { CustomAppState } from "@conklin/App/Store/Reducers";
import IconHeaderQuickOrder from "@conklin/XDL/Icons/IconHeaderQuickOrder";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";

const HeaderQuickOrder = () => {
    const history = useHistory();

    const { isTabletScreen, quickOrderPageUrl, userName, currentUserIsGuest } = useAppSelector(state => ({
        isTabletScreen: (state as CustomAppState).xCommon.isTabletScreen,
        quickOrderPageUrl: getPageLinkByPageType(state, "QuickOrderPage")?.url || "/QuickOrder",
        userName: state.context.session?.userName || "",
        currentUserIsGuest: getCurrentUserIsGuest(state),
    }));

    if (!userName || currentUserIsGuest) {
        return null;
    }
    const openQuickOrderPageHandler = () => {
        history.push(quickOrderPageUrl);
    };

    if (isTabletScreen) {
        return null;
    }

    return (
        <HeaderClickable
            iconProps={{
                src: IconHeaderQuickOrder,
            }}
            data-test-selector="quickOrder"
            title={translate("Quick Order")}
            onClick={openQuickOrderPageHandler}
            showArrow={false}
        />
    );
};

const widgetModule: WidgetModule = {
    component: HeaderQuickOrder,
    definition: {
        displayName: "Header Quick Order",
        group: "Common",
        allowedContexts: ["Header"],
    },
};

export default widgetModule;
